import { render, staticRenderFns } from "./OrganizationHome.vue?vue&type=template&id=0770c30c&scoped=true&"
import script from "./OrganizationHome.vue?vue&type=script&lang=js&"
export * from "./OrganizationHome.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationHome.vue?vue&type=style&index=0&id=0770c30c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0770c30c",
  null
  
)

export default component.exports